export const PAMP_URL = 'https://www.pamp.com';

export const PAMP_HIRING_URL = 'https://careers.mkspampgroup.com';
